export default function ProfileField({ label, value }) {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between py-3 border-gray-200">
      <span className="text-[#1E3A5F] font-semibold mb-1 sm:mb-0">{label}:</span>
      <span className="text-[#1E3A5F] text-right">
        {value ? value : <span className="text-red-500">تکمیل نشده</span>}
      </span>
    </div>
  );
}
